__turbopack_context__.v({
  "AwardStatus": "Item-module-sass-module__uGHbIG__AwardStatus",
  "Button": "Item-module-sass-module__uGHbIG__Button",
  "Copy": "Item-module-sass-module__uGHbIG__Copy",
  "Download": "Item-module-sass-module__uGHbIG__Download",
  "Image": "Item-module-sass-module__uGHbIG__Image",
  "Inner": "Item-module-sass-module__uGHbIG__Inner",
  "Item": "Item-module-sass-module__uGHbIG__Item",
  "Link": "Item-module-sass-module__uGHbIG__Link",
  "Main": "Item-module-sass-module__uGHbIG__Main",
  "Subtitle": "Item-module-sass-module__uGHbIG__Subtitle",
  "Title": "Item-module-sass-module__uGHbIG__Title",
  "Year": "Item-module-sass-module__uGHbIG__Year",
});
